import { Box, Grid, Typography } from "@mui/material";
import JWTNewPasswordView from "./jwt-new-password-view";
import { m } from "framer-motion";
import JWTLoginNewPasswordView from "./jwt-login-new-password-view";

export default function LoginNewPasswordPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#f5f5f5",
        py: 5,
      }}
    >
      <Grid
        container
        sx={{
          width: { xs: "90%", md: "70%" },
          borderRadius: 3,
          overflow: "hidden",
          boxShadow: 4,
        }}
      >
        {/* Left Section */}
        <Grid
          item
          xs={12}
          md={5} // smaller than right side
          sx={{
            bgcolor: "#0B0C10",
            color: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            p: 4,
          }}
          component={m.div}
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Set a New Password
          </Typography>
          <Typography variant="subtitle1">
            Please enter a new password.
          </Typography>
        </Grid>

        {/* Right Section */}
        <Grid
          item
          xs={12}
          md={7} // bigger than left side
          sx={{
            bgcolor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 4,
          }}
          component={m.div}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Box sx={{ width: "100%", maxWidth: 400 }}>
            <JWTLoginNewPasswordView />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

